import {DataProviderDataResponse} from '@/services/datatable/datatable.service';

/**
 * Abstract definition of a Datatable Search Provider
 */
abstract class SearchProvider {

    readonly templateUrl: string;
    readonly initialTableData: DisguiseDto.DTTemplateDto;
    readonly initialInputConfig: Partial<DisguiseDto.DTTemplateDto>;

    constructor(templateUrl: string, table: DisguiseDto.DTTemplateDto, inputConfig:
        DisguiseDto.DTInputConfigurationDto) {
        this.templateUrl = templateUrl;
        this.initialTableData = {...table};
        this.initialInputConfig = {...inputConfig};
    }

    /**
     * Returns the requested table data. Necessary to handle subsequent calls after the first one.
     * @param inputConfig the current input config
     */
    abstract getData(inputConfig: DisguiseDto.DTInputConfigurationDto): Promise<DataProviderDataResponse>;

    /**
     * Returns the initial table data. Necessary to handle the first call
     * @param inputConfig the current input config
     */
    abstract getInitialData(inputConfig: DisguiseDto.DTInputConfigurationDto): DataProviderDataResponse;
}

export {
    SearchProvider
};
